// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"5a93df0f","198":"0a95aa7d","227":"5c06caa5","310":"a4a7ab2d","488":"29b71886","713":"e72793ea","735":"5353191f"}[chunkId] + ".chunk.js";
};